import { IconHelpCircle, IconPlus, IconSidebar } from 'featherico';
import moment from 'moment';
import NotificationsTrigger from '../../react/components/Notifications/NotificationsTrigger/withProvider';
import GlobalCreate from '../../react/features/AppHeader/components/GlobalCreate';
import { HelpMenu, useReleaseNotes } from '../../react/features/AppHeader/components/HelpMenu';
import UserMenu from '../../react/features/AppHeader/components/UserMenu';
import HeaderSearchBar from '../../react/features/HeaderSearchBar/container';
import { JustLaunchedBubble } from '../../react/features/JustLaunched';
import { NavItemButton } from '../../react/features/Navigation/Item';
import { useAppContext } from '../../react/hooks/useAppContext';
import { useNow } from '../../react/hooks/useNow';
import styles from './style.m.less';

type Props = {
    onExpand: () => void;
};

export function ListActionsCompact() {
    const { user } = useAppContext();
    const now = useNow(moment.duration(1, 'hour'));
    const releaseNotes = useReleaseNotes(user, now);
    const menuPlacement = 'right-end';
    return (
        <>
            <div className={styles.justLaunchedPopover}>
                <JustLaunchedBubble />
            </div>
            <div className={styles.section}>
                {!user.isGuest && (
                    <>
                        <GlobalCreate
                            user={user}
                            trigger={<NavItemButton icon={<IconPlus />} label="Create" compact />}
                            placement={menuPlacement}
                        />
                        <HeaderSearchBar compact />
                    </>
                )}
                <HelpMenu
                    user={user}
                    now={now}
                    releaseNotes={releaseNotes}
                    trigger={
                        <NavItemButton
                            icon={<IconHelpCircle />}
                            label="Help"
                            notification={releaseNotes.hasNewReleaseNotes ? { count: 1, type: 'INFO' } : undefined}
                            compact
                        />
                    }
                    placement={menuPlacement}
                />
                <NotificationsTrigger compact />
            </div>
        </>
    );
}

export function BottomActionsCompact({ onExpand }: Props) {
    const { user } = useAppContext();
    return (
        <div className={styles.sectionBottom}>
            <NavItemButton icon={<IconSidebar />} label="Expand Navigation" compact onClick={onExpand} />
            <UserMenu user={user} navStyle="compact" />
        </div>
    );
}
